import React, { useRef, useState } from "react";
import { useLatest, useUpdateEffect } from "ahooks";
import HasPermission from "@/components/commons/HasPermission";
import { useGroupDeviceDispatch, useGroupDeviceState } from "../Provider";
import { useGlobalState, useGlobalDispatch } from "../../../GlobalProvider";
import CategoryTreeWrapper from "./CategoryTreeWrapper";
import ImportGroupDialog from "./Import/ImportDialog";

const Category = React.memo(() => {
  const tree = useRef(null);
  const [importDialogOpen, setImportDialogOpen] = useState(false);
  const [importGroupId, setImportGroupId] = useState("");
  const {
    setCurrentGroup,
    updateCurrentGroup,
    resetCurrentGroup,
    setCurrentTag,
    setFilterBy,
    setLoadingGroup,
    setCheckable
  } = useGroupDeviceDispatch();

  const {
    currentTag,
    filterByMode,
    filterBy,
    reloadTreeFlag,
    currentGroup,
    checkable
  } = useGroupDeviceState();
  const { currentCompanyId, showDetail } = useGlobalState();

  const currentGroupRef = useLatest(currentGroup);
  const filterByModeRef = useLatest(filterByMode);
  const filterByRef = useLatest(filterBy);

  const [selectedKeys, setSelectedKeys] = useState(
    currentTag || filterByMode ? [] : undefined
  );
  const [checkedKeys, setCheckedKeys] = useState();

  const handleCheck = (checkedKeys, info) => {
    updateCurrentGroup({ id: checkedKeys, checkedGroups: info.checkedNodes });
  };

  const handleSwitch = on => {
    setCheckable(on);
    if (on) {
      updateCurrentGroup({ checkedGroups: [] });
    } else {
      resetCurrentGroup(false, state => {
        if (state.currentGroup) {
          setSelectedKeys([state.currentGroup.key]);
        }
      });
    }
  };

  const handleSetCurrentGroup = (keys, nodeInfo) => {
    setCurrentGroup(nodeInfo.node, true);
    // console.log("------keys-----",keys)
  };

  const handleLoaded = treeData => {
    const currentGroup = currentGroupRef.current;

    if (filterByModeRef.current) {
      setFilterBy(filterByRef.current);
    } else if (currentTag) {
      setCurrentTag(currentTag);
    } else if (currentGroup) {
      if (!currentGroup.checkedGroups) {
        setCurrentGroup(currentGroup, true);
        setSelectedKeys([currentGroup.key]);
      } else {
        setCheckedKeys(currentGroup.checkedGroups.map(item => item.key));
        setLoadingGroup(false);
      }
    } else {
      setCurrentGroup(treeData[0], true);
    }
  };

  const onNodeImport = nodeInfo => {
    setImportDialogOpen(true);
    if (nodeInfo.isRoot) {
      setImportGroupId("");
    } else {
      setImportGroupId(nodeInfo.key);
    }
  };

  const onImportGroupSuccess = () => {
    tree.current?.reload();
  };

  useUpdateEffect(() => {
    if (currentCompanyId) {
      setSelectedKeys(undefined);
      resetCurrentGroup(true);
      tree.current?.reload();
    }
  }, [currentCompanyId]);

  useUpdateEffect(() => {
    if (reloadTreeFlag) {
      tree.current?.reload(true);
    }
  }, [reloadTreeFlag]);

  useUpdateEffect(() => {
    if (currentTag || filterByMode) {
      setSelectedKeys([]);
      // setCurrentGroup(tree.current?.getTreeData()[0]);
    }
  }, [currentTag, filterByMode]);

  return (
    <>
      <CategoryTreeWrapper
        showSwitch={false}
        ref={tree}
        editable={true}
        sortable={true}
        readOnly={true}
        checkable={checkable} // 是否全选
        disabledCheckAllNode
        checkStrictly
        selectable={!currentGroup || !currentGroup.checkedGroups}
        selectedKeys={selectedKeys}
        checkedKeys={checkedKeys}
        importable={true}
        onSelect={handleSetCurrentGroup}
        onCheck={handleCheck}
        onSwitch={handleSwitch}
        onLoaded={handleLoaded}
        onNodeImport={onNodeImport}
      />
      <ImportGroupDialog
        open={importDialogOpen}
        groupId={importGroupId}
        onSuccess={onImportGroupSuccess}
        onClose={() => setImportDialogOpen(false)}
      />
    </>
  );
});

export default Category;
